import axios from "@/libs/api.request";

export const getPickChannel = (params) => {
  return axios.request({
    url: "/warehouse/packing/channel",
    method: "get",
    params,
  });
};

export const getPickShipents = (data) => {
  return axios.request({
    url: "/warehouse/packing/shipments",
    method: "post",
    data,
  });
};

export const add = (data) => {
  let url = ""
  if (data.transfer) url = "/warehouse/packing/saveTransport";
  else url = "/warehouse/packing";
  return axios.request({
    url,
    method: "post",
    data,
  });
};

export const getPicking = (data) => {
  return axios.request({
    url: "/warehouse/packing/index",
    method: "post",
    data,
  });
};

export const del = (id) => {
  return axios.request({
    url: `/warehouse/packing/${id}`,
    method: "delete",
  });
};

export const postCnbNum = (data) => {
  return axios.request({
    url: `/warehouse/packing/airwayNumber`,
    method: "POST",
    data,
  });
};
// 更新中港单出入仓时间
export const boundTime = (data) => {
  return axios.request({
    url: `/warehouse/packing/${data.id}`,
    method: "PUT",
    data,
  });
};

// 添加中港单轨迹
export const addTrace = (data) => {
  return axios.request({
    url: `/warehouse/packing/addTrace/${data.id}`,
    method: "post",
    data,
  });
};

// 添加中港单轨迹
export const handlePacking = (data) => {
  return axios.request({
    url: `/warehouse/packing/handlePacking/${data.id}`,
    method: "PUT",
    data,
  });
};

export const getPackageWarehouse = () => {
  return axios.request({
    url: `/warehouse/warehouse/getPackageWarehouse`,
    method: "get",
  });
};

export const exportPacking = (data) => {
  return axios.request({
    url: `/warehouse/packing/exportPacking`,
    method: "post",
    data,
  });
};

export const exportPackingZip = (data) => {
  return axios.request({
    url: `/warehouse/packing/exportPackingZip`,
    method: "post",
    data,
  });
};

export const exportOutboundData = (data) => {
  return axios.request({
    url: `/warehouse/packing/exportDailyOutbound`,
    method: "post",
    data,
  });
};

export const exportCustomsData = (data) => {
  return axios.request({
    url: `/warehouse/packing/exportCustomsData`,
    method: "post",
    data,
  });
};

// 新建b2b中港单

// 获取目的机场
export const dblpackingAir = (params) => {
  return axios.request({
    url: `/common/transport/airPort`,
    method: "get",
    params,
  });
};

// 获取b2b单号
export const dblpackingOrder = (params) => {
  return axios.request({
    url: `/common/transport/dblorder`,
    method: "get",
    params,
  });
};

// 创建b2b中港单
export const postDblpacking = (data) => {
  return axios.request({
    url: `/warehouse/dblpacking${data.id ? "/" + data.id : ""}`,
    data,
    // [params.method && params.method != "get" ? "data" : "params"]: params,
    method: data.method ? data.method : "get",
  });
};

// b2b中港单查看
export const showDblpacking = (data) => {
  return axios.request({
    url: `/warehouse/dblpacking/airwayNumber`,
    method: "POST",
    data,
  });
};

// b2b中港单录轨迹
export const addDblpackingTrace = (data) => {
  return axios.request({
    url: `/warehouse/dblpacking/addTrace/${data.id}`,
    method: "post",
    data,
  });
};

// 获取订单体积、重量、件数
export const getOrderInfo = (data) => {
  return axios.request({
    url: `/warehouse/dblpacking/orderinfo`,
    method: "post",
    data,
  });
};

// 更新订单体积、重量、件数
export const updateOrderInfo = (data) => {
  return axios.request({
    url: `/warehouse/packing/details`,
    method: "post",
    data,
  });
};

// 获取下港方式
export const getDownPort = (params) => {
  return axios.request({
    url: `/common/transport/lowerPort`,
    method: "get",
    params,
  });
};

// 获取操作日志
export const getLog = (params) => {
  return axios.request({
    url: `/warehouse/packing/packingLog`,
    method: "get",
    params,
  });
};

export const caseNumber = (params) => {
  return axios.request({
    url: `/common/caseNumber`,
    method: "get",
    params,
  });
};

export const move = (data) => {
  return axios.request({
    url: `/warehouse/dblpacking/move/` + data.id,
    method: "post",
    data,
  });
};

export const airway_number = (data) => {
  return axios.request({
    url: `/warehouse/dblpacking/airway_number`,
    method: "post",
    data,
  });
};

export const warehouse_number = (params) => {
  return axios.request({
    url: `/warehouse/airpacking/warehouse_number`,
    method: "get",
    params,
  });
};

export const getBatch = (params) => {
  return axios.request({
    url: `/warehouse/airpacking/getBatch`,
    method: "get",
    params,
  });
};

export const createTransport = (data) => {
  return axios.request({
    url: `/warehouse/packing/createTransport`,
    method: "post",
    data,
  });
};

export const batchRemarks = (data) => {
  return axios.request({
    url: `/warehouse/warehouse/batchRemarks`,
    method: "post",
    data,
  });
};
